import { render, staticRenderFns } from "./tab-layout.vue?vue&type=template&id=26f75da0&scoped=true"
import script from "./tab-layout.vue?vue&type=script&lang=js"
export * from "./tab-layout.vue?vue&type=script&lang=js"
import style0 from "./tab-layout.vue?vue&type=style&index=0&id=26f75da0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f75da0",
  null
  
)

export default component.exports